<template>
    <div class="container">
        <div class="container">
            <div class="top">
                <div class="title">
                    银行卡信息完善
                </div>
                <div @click="back" style="width: 16vw; height: 16vw; position: absolute; display: flex; align-items: center; top: 2vw; left: 2vw">
                    <img style="width: 10vw; height: 7.93vw;" src="../assets/back.png" />
                </div>

                <div style="font-size: 18px; font-weight: 500; margin-top: 20vw; margin-left: 6vw">
                    基础信息<span style="color: red">*</span>
                </div>
                <div style="font-size: 15px; font-weight: 300; color: #555; margin-top: 2vw; margin-left: 6vw; margin-right: 6vw;">
                    <span style="color: red">*</span>请确保您的本人姓名、身份证、银行卡信息、手机号准确无误（若信息填写错误，可能导致打款失败）
                </div>

                <div style="font-size: 18px; font-weight: 500; margin-top: 6vw; margin-left: 6vw">
                    <span style="color: red">*</span>
                    <input type="text" v-model="name" placeholder="请输入本人姓名" class="input_style" />
                </div>
                <div style="font-size: 18px; font-weight: 500; margin-top: 4vw; margin-left: 6vw">
                    <span style="color: red">*</span>
                    <input type="text" v-model="id_number" placeholder="请输入本人身份证号码" class="input_style" />
                </div>

                <div style="font-size: 18px; font-weight: 500; margin-top: 4vw; margin-left: 6vw">
                    <span style="color: red">*</span>
                    <input type="text" v-model="bank_card" placeholder="请输入本人银行卡" class="input_style" />
                </div>
                <div style="font-size: 18px; font-weight: 500; margin-top: 4vw; margin-left: 6vw">
                    <span style="color: red">*</span>
                    <input type="text" v-model="phone" placeholder="请输入本人手机号码" class="input_style" />
                </div>


                <div style="font-size: 18px; font-weight: 500; margin-top: 10vw; margin-left: 6vw">
                    其他信息
                </div>
                <div style="font-size: 18px; font-weight: 500; margin-top: 4vw; margin-left: 6vw; padding-left: 2vw;">
                    <input type="text" v-model="bank_address" placeholder="请输入银行开户支行" class="input_style" />
                </div>
                <div style="font-size: 18px; font-weight: 500; margin-top: 4vw; margin-left: 6vw; padding-left: 2vw;">
                    <input type="text" v-model="mark" placeholder="其他备注" class="input_style" />
                </div>

            </div>

            <div style="flex: 1"></div>
            <div @click="btnSubmit" style="display: flex; width: 88vw; height: 12vw; background: linear-gradient(to right, #CBACFF, #7384FF); align-self: center; margin-bottom: 10vw; justify-content: center; align-items: center; font-size: 20px; font-weight: 500; color: white; border-radius: 28px;">
                {{ btnTitle }}
            </div>
        </div>
    </div>
</template>



<script>
import axios from 'axios';
import { prefix, prefix_dev, userBankSetBank, userFinance } from '../url';
import ProfitHelper from '../ProfitHelper';

export default ({
    data() {
        return {
            urlPrefix: prefix,
            head: {
                version: '',
                edition: '',
                aps: '',
                Authorization: '',
                os: 1,
            },

            withdrawList: [],
            btnTitle: '确认提交',
            name: '',
            id_number: '',
            bank_card: '',
            phone: '',
            bank_address: '',
            mark: '',
            user_score: 0.00
        };
    },

    created() {
        this.formatUrlParams();
    },

    methods: {
        formatUrlParams() {
            if (localStorage.getItem('is_dev') == 'yes') {
                this.urlPrefix = prefix_dev;
            }
            this.head.version = localStorage.getItem('version');
            this.head.edition = localStorage.getItem('edition');
            this.head.aps = localStorage.getItem('aps');
            this.head.Authorization = localStorage.getItem('Authorization');

            this.user_score = parseFloat(localStorage.getItem("user_score"));
            this.name = localStorage.getItem('bank_real_name');
            this.id_number = localStorage.getItem('bank_id_card');
            this.bank_card = localStorage.getItem('bank_account');
            this.phone = localStorage.getItem('bank_phone');
            this.bank_address = localStorage.getItem('bank_name');
            this.mark = localStorage.getItem('bank_comment');
        },

        back() {
            window.location.href = '/profit-account';
        },

        btnSubmit() {
            const url = this.urlPrefix + userBankSetBank;
            let params = {
                account: this.bank_card,
                real_name: this.name,
                id_card: this.id_number,
                phone: this.phone,
                bank_name: this.bank_address,
                comment: this.mark,
            };
            params.sign = ProfitHelper.getPostSign(JSON.stringify(params));
            axios.post(url, params, { headers: this.head }).then(res => {
                console.log('res response response val si -- - - - ------->', res.data);
                const data = res.data.data;
                if (data == true) {
                    this.back();
                } else {
                    alert(res.data.msg);
                }
            }).catch(err => { });
        }
    }
})
</script>



<style scoped>
.container {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: white;
}
.loading {
    width: 100vw;
    height: 100vh;
    position: absolute;
    background-color: white;
}

.top {
    width: 100vw;
    /* height: 74.6vw; */
    display: flex;
    flex-direction: column;
}
.title {
    position: absolute;
    top: 6vw;
    width: 100%;
    text-align: center;
    font-size: 18px;
}

.account_type {
    display: flex;
    flex-direction: row;
    padding-left: 6vw;
    align-items: center;
    width: 100%;
    /* background-color: aqua; */
}
.input_style {
    width: 80vw; height: 8vw; border-radius: 8px; border: 1px #CCC solid; margin-left: 2vw
}
</style>